
const types = {
  ADD_INCOMING_CHAT: 'ADD_INCOMING_CHAT',
  REMOVE_INCOMING_CHAT: 'REMOVE_INCOMING_CHAT',
  CLEAR_INCOMING_CHATS: 'CLEAR_INCOMING_CHATS',
};

const initialState = {
  records: {},
};

export const getters = {
  getIncomingChats: $state => Object.values($state.records),
  hasIncomingChats: $state => Object.keys($state.records).length > 0,
};

export const actions = {
  addIncomingChat({ commit }, chatData) {
    commit(types.ADD_INCOMING_CHAT, chatData);
  },
  removeIncomingChat({ commit }, chatId) {
    commit(types.REMOVE_INCOMING_CHAT, chatId);
  },
  clearIncomingChats({ commit }) {
    commit(types.CLEAR_INCOMING_CHATS);
  },
};

export const mutations = {
  [types.ADD_INCOMING_CHAT]($state, chatData) {
    $state.records[chatData.id] = chatData;
  },
  [types.REMOVE_INCOMING_CHAT]($state, chatId) {
    delete $state.records[chatId];
  },
  [types.CLEAR_INCOMING_CHATS]($state) {
    $state.records = {};
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
